import moment from 'moment';
import { filter } from 'lodash';

// A row's creator segment for CreatorCell, from the API `signals` (by_user rows, by_link owners):
// the lifetime character and its three bits; null outside the signals population
export const segmentFields = signals => ({
  segment: signals ? signals.char_name : null,
  segment_signals: signals ? {
    links: signals.char_lifetime_links_bit ? 'above' : 'below',
    reach: signals.char_lifetime_clicks_bit ? 'above' : 'below',
    sales: signals.char_lifetime_sales_bit ? 'above' : 'below'
  } : null
});

export const prepareFilters = filters => {
  const obj = filter(filters, x => x.selected).reduce((obj, item) => {
    switch (item.key) {
      case 'date': {
        switch (item.value.type) {
          case 'previous_month': {
            return ({ ...obj, since: 'now-1M/M', until: 'now/M' });
          }
          case 'this_month': {
            return ({ ...obj, since: 'now/M' });
          }
          case 'last_days': {
            return ({ ...obj, since: `now-${item.value.number}d/d`, until: 'now+1d/d' });
          }
          default: {
            return ({ ...obj, since: `${item.value.since}||/d`, until: `${item.value.until}||/d` });
          }
        }
      }
      case 'users': {
        return ({ ...obj, owner_uuids: item.value, user_uuids: item.value });
      }
      // case 'campaign_modifiers': {
      //   return ({ ...obj, modifier_ids: item.value.map(x => x.id) });
      // }
      case 'campaigns': {
        return ({ ...obj, campaign_ids: item.value.map(x => x.id) });
      }
      case 'lookbooks': {
        return ({ ...obj, lookbook_ids: item.value.map(x => x.id) });
      }
      case 'discount_codes': {
        return ({ ...obj, discount_code_ids: item.value.map(x => x.id) });
      }
      case 'connected_since': {
        if (!item.value) return obj;
        return ({ ...obj, connected_since: moment().subtract(7, 'days').startOf('day').format() });
      }
      case 'active_links_range': {
        const activeLinksResult = {};
        if (item.value.min !== '') activeLinksResult.min_filtered_active_links = parseInt(item.value.min);
        if (item.value.max !== '') activeLinksResult.max_filtered_active_links = parseInt(item.value.max);
        return { ...obj, ...activeLinksResult };
      }
      case 'clicks_range': {
        const clicksResult = {};
        if (item.value.min !== '') clicksResult.min_filtered_clicks = parseInt(item.value.min);
        if (item.value.max !== '') clicksResult.max_filtered_clicks = parseInt(item.value.max);
        return { ...obj, ...clicksResult };
      }
      case 'gmv_range': {
        const gmvResult = {};
        if (item.value.min !== '') gmvResult.min_filtered_gmv = item.value.min;
        if (item.value.max !== '') gmvResult.max_filtered_gmv = item.value.max;
        return { ...obj, ...gmvResult };
      }
      default: {
        return ({ ...obj, [item.key]: item.value });
      }
    }
  }, {});

  return obj;
};